import { getSectors } from '../api'

const initialState = {
    sector: 'BELLAVISTA',
    isLoading: true,
    options: []
}

export const sector = ({
    state: initialState,
    reducers: {
        setSector(state, sector) {
            return {
                ...state,
                ...sector,
                isLoading: false
            }
        },
        setSelectOptions(state, options){
            return {
                ...state,
                ...options,
                isLoading: false
            }
        }
    },
    effects: {
        changeSector(sector) {
            this.setSector({ sector: sector.value });
        },
        async loadSelectOptions() {
            const sectors = await getSectors();
            this.setSelectOptions(sectors);
        }
    }
})
